export const EXTERNAL_LINKS = {
  termsOfUse: "https://lezz.social/termos",
  privacyPolicy: "https://lezz.social/privacidade",
  support: "https://lezz.social/suporte",
} as const;
